<template>
<span class="label" :class="classes">
  {{ stateForHuman }}
</span>
</template>
<script>
export default {
  props: {
    state: {type: String, required: true}
  },
  computed: {
    classes () {
      return {
        'label-danger': this.state !== 'realized',
        'label-success': this.state === 'realized'
      }
    },
    stateForHuman () {
      switch (this.state) {
        case 'realized':
          return 'TAK'
        default:
          return 'NIE'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaymentState.vue?64974394